import type {ReactElement} from 'react';
import React from 'react';
import {BaseTextFillColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-fill-color-panel';
import type {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import type {RGBA} from '@Utils/color.util';
import {updateLastAddedTextColor} from '@Components/poster-editor/library/poster-editor-library';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromFillOfTextStylesOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfTextStylesOfActiveItem';

interface TextFillColorPanelProps {
  isForLayoutItem?: boolean;
}

export function TextFillColorPanel({isForLayoutItem = false}: TextFillColorPanelProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemFillType = useGetKeyFromFillOfTextStylesOfActiveItem('fillType');
  const itemFillColor = useGetKeyFromFillOfTextStylesOfActiveItem('fillColor');

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || !itemFillColor || itemFillType === undefined) {
    throw new Error(`Item doesn't have text styles property`);
  }

  const updateFillColor = (fillColor: RGBA[], undoable = true): void => {
    void activeItem.updateFromObject(
      {
        textStyles: {
          fill: {
            fillColor,
          },
        },
        list: {
          fill: {
            fillColor,
          },
        },
      },
      {undoable}
    );
    updateLastAddedTextColor(fillColor[0]);
  };

  const onChangeType = (newType: FillTypes): void => {
    const fillObject = {
      fillType: newType,
      fillColor: activeItem.textStyles.fill.getColorForNewType(newType),
    };
    void activeItem.updateFromObject({
      textStyles: {
        fill: {
          ...fillObject,
        },
      },
      list: {
        fill: {
          ...fillObject,
        },
      },
    });
  };

  return (
    <BaseTextFillColorPanel
      fillObject={{
        fillType: itemFillType,
        fillColor: itemFillColor,
      }}
      onUpdateColor={updateFillColor}
      onChangeType={onChangeType}
      isForLayoutItem={isForLayoutItem}
    />
  );
}
